// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Mobile devices */
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .why-olci {
  padding: 0;
}
:host-context(.aulani) .why-olci .all-sections-on-file {
  padding-bottom: 12px;
}
:host-context(.aulani) .why-olci .header-section {
  float: left;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
:host-context(.aulani) .why-olci .header-section .left-header {
  width: 50%;
}
:host-context(.aulani) .why-olci .header-section .left-header .olci-header {
  font-family: Goudy-Regular;
  font-size: 48px;
  line-height: 44px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
}
:host-context(.aulani) .why-olci .header-section .right-header {
  width: 50%;
}
:host-context(.aulani) .why-olci .header-section .right-header .resort-name {
  font-family: "InspireTWDCRoman";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  text-align: right;
  margin-bottom: 5px;
}
:host-context(.aulani) .why-olci .header-section .right-header .period-of-stay {
  font-family: "InspireTWDCRoman";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  text-align: right;
}
:host-context(.aulani) .why-olci .info-section {
  float: left;
  margin-left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 24px;
  padding-bottom: 12px;
}
:host-context(.aulani) .why-olci .info-section .description {
  width: 50%;
  font-family: "InspireTWDCRoman";
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
}
:host-context(.aulani) .why-olci .info-section .required-field {
  width: 50%;
  font-family: "InspireTWDCRoman";
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  display: block;
  text-align: right;
}
:host-context(.aulani) .why-olci .aulani-info .title {
  font-family: "InspireTWDCRoman";
  font-size: 28px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: 0;
  color: #382613;
  width: auto;
  margin-top: 0px;
}
:host-context(.aulani) .why-olci .aulani-info .horizontal-line {
  background-image: radial-gradient(#918F8C 0%, #FFF 100%);
  height: 1px;
  margin: 0 0 32px 0;
  border-bottom: thin solid #918F8C;
  background-image: none;
}
:host-context(.aulani) .why-olci .aulani-info .aulani-global-error {
  margin-bottom: 20px;
  --font16_-_line-height: 21px;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .why-olci {
    padding: 0 20px;
  }
  :host-context(.aulani) .why-olci .aulani-info .title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .why-olci .aulani-info .horizontal-line {
    margin: 0 0 32px 0;
  }
  :host-context(.aulani) .why-olci .header-section {
    width: 100%;
    flex-direction: column;
  }
  :host-context(.aulani) .why-olci .header-section .left-header {
    width: 100%;
  }
  :host-context(.aulani) .why-olci .header-section .left-header .olci-header {
    font-size: 32px;
    line-height: 38px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .why-olci .header-section .right-header {
    width: 100%;
  }
  :host-context(.aulani) .why-olci .header-section .right-header .resort-name {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    margin: 12px 0 0 0;
  }
  :host-context(.aulani) .why-olci .header-section .right-header .period-of-stay {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    margin-top: 5px;
  }
  :host-context(.aulani) .why-olci .info-section {
    width: 100%;
    flex-direction: column;
    padding-top: 24px;
  }
  :host-context(.aulani) .why-olci .info-section .description {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    width: 100%;
  }
  :host-context(.aulani) .why-olci .info-section .required-field {
    font-family: "InspireTWDCRoman";
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    color: #382613;
    width: 100%;
    text-align: left;
    margin-top: 12px;
  }
  :host-context(.aulani) .why-olci.all-sections-on-file .info-section .required-field {
    display: block;
    margin-top: 10px;
  }
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For MOBILE */
  /* Small Devices, Tablets */
  /* For Desktop */
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .why-olci .title {
  color: #424B5A;
}
:host-context(.wdw) .why-olci h2 {
  color: #424B5A;
}
:host-context(.wdw) .why-olci .period-of-stay {
  color: #78899E;
}
:host-context(.wdw) .why-olci .description {
  color: #253B56;
}
:host-context(.wdw) .why-olci .descriptionDOF {
  color: #424B5A;
}
:host-context(.wdw) .why-olci .required-field {
  color: #78899E;
}
:host-context(.wdw) .why-olci .horizontal-line {
  border-bottom: thin solid #D8D8D8;
}
:host-context(.wdw) .why-olci .resort-name {
  color: #78899E;
}
@media only screen and (min-width: 320px) {
  :host-context(.wdw) .why-olci .parent-container {
    padding: 0 10px;
  }
  :host-context(.wdw) .why-olci .content-container + div.horizontal-line {
    display: none;
  }
  :host-context(.wdw) .why-olci .title {
    font-family: "InspireTWDCRoman";
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 33px;
  }
  :host-context(.wdw) .why-olci h2 {
    font-family: "InspireTWDCRoman";
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 33px;
  }
  :host-context(.wdw) .why-olci .period-of-stay {
    font-family: "InspireTWDCMedium";
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0;
    margin-top: 6px;
  }
  :host-context(.wdw) .why-olci .description {
    font-family: "InspireTWDCMedium";
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }
  :host-context(.wdw) .why-olci .descriptionDOF {
    line-height: 20px;
    font-family: "InspireTWDCRoman";
  }
  :host-context(.wdw) .why-olci .required-field {
    font-family: "InspireTWDCMedium";
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 28px;
    margin-top: -7px;
  }
  :host-context(.wdw) .why-olci .horizontal-line {
    height: 1px;
  }
  :host-context(.wdw) .why-olci .left-section .title {
    display: none;
  }
  :host-context(.wdw) .why-olci .left-section .description {
    padding-top: 24px;
    margin-bottom: 10px;
  }
  :host-context(.wdw) .why-olci .right-section .resort-name {
    font-family: "InspireTWDCHeavy";
    font-size: 14px;
    letter-spacing: 0;
  }
  :host-context(.wdw) .why-olci .right-section .horizontal-line {
    margin: 24px -10px 20px;
  }
  :host-context(.wdw) .why-olci .right-section .title {
    margin-bottom: 40px;
  }
  :host-context(.wdw) .why-olci .right-section .required-field {
    margin-bottom: 0px;
  }
  :host-context(.wdw) .why-olci.all-sections-on-file .content-container + div.horizontal-line {
    display: block;
    margin-top: 15px;
    margin-left: -10px;
    margin-right: -10px;
  }
  :host-context(.wdw) .why-olci.all-sections-on-file .required-field {
    margin-top: 7px;
  }
}
@media only screen and (min-width: 768px) {
  :host-context(.wdw) .why-olci .parent-container {
    padding: 0 40px 0 40px;
  }
  :host-context(.wdw) .why-olci .content-container + div.horizontal-line {
    display: block;
    margin: 30px -40px 0;
  }
  :host-context(.wdw) .why-olci .left-section .title {
    display: block;
    padding-top: 40px;
  }
  :host-context(.wdw) .why-olci .left-section .description {
    padding-top: 10px;
    margin-bottom: 15px;
  }
  :host-context(.wdw) .why-olci .right-section .title,
  :host-context(.wdw) .why-olci .right-section .horizontal-line {
    display: none;
  }
  :host-context(.wdw) .why-olci .right-section .resort-name {
    font-family: "InspireTWDCHeavy";
  }
  :host-context(.wdw) .why-olci .right-section .period-of-stay {
    font-family: "InspireTWDCRoman";
    font-weight: 400;
  }
  :host-context(.wdw) .why-olci .right-section .required-field {
    margin-top: 11px;
    margin-bottom: 0;
    font-family: "InspireTWDCRoman";
    font-weight: 400;
  }
  :host-context(.wdw) .why-olci.all-sections-on-file .content-container + div.horizontal-line {
    margin-right: -40px;
    margin-left: -40px;
  }
  :host-context(.wdw) .why-olci.all-sections-on-file .left-section .description {
    padding-top: 24px;
  }
}
@media screen and (min-width: 992px) {
  :host-context(.wdw) .why-olci .parent-container {
    padding: 40px 40px 0px 40px;
  }
  :host-context(.wdw) .why-olci .content-container + div.horizontal-line {
    margin: 0 -40px 0 -40px;
  }
  :host-context(.wdw) .why-olci .left-section {
    float: left;
    width: 535px;
    margin-bottom: 30px;
  }
  :host-context(.wdw) .why-olci .left-section .title {
    display: block;
    padding-top: 0px;
  }
  :host-context(.wdw) .why-olci .left-section .description {
    margin-bottom: 0px;
  }
  :host-context(.wdw) .why-olci .right-section {
    float: right;
    width: 309px;
    text-align: right;
    margin-top: 9px;
  }
  :host-context(.wdw) .why-olci .right-section .period-of-stay {
    font-family: "InspireTWDCMedium";
    font-weight: 400;
  }
  :host-context(.wdw) .why-olci .right-section .required-field {
    margin-top: 10px;
    margin-bottom: 0;
    font-family: "InspireTWDCMedium";
    font-weight: 400;
  }
  :host-context(.wdw) .why-olci.all-sections-on-file .left-section .description {
    padding-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/about-olci/about-olci.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/about-olci/about-olci.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/app/about-olci/about-olci.component.wdw.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ECmGA,uBAAA;AP9DA;AK9BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALgCJ;AK9BI;EAEI,sBAAA;AL+BR;AK5BI;EACI,wBAAA;AL8BR;AK1BA;;EAEI,SAAA;EACA,iBAAA;AL4BJ;AKzBA;EACI,WAAA;AL2BJ;AKxBA;EACI,WAAA;AL0BJ;AKvBA;;;;;EAKI,SAAA;ALyBJ;AKtBA;;;;;;;;;;;;EAYI,oBAAA;ALwBJ;AKrBA;EACI,OAAA;ALuBJ;AKrBI;EACI,WAAA;ALuBR;AKpBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALqBR;AKjBA;EACI,WAAA;ALmBJ;AKhBA;EACI,YAAA;ALkBJ;AMlGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANoGJ;AMjGA;;;;;;;;;;;;EAYI,cAAA;ANmGJ;AMhGA;;EAEI,gBAAA;ANkGJ;AM/FA;;EAEI,YAAA;ANiGJ;AM/FI;;;;EAEI,aAAA;ANmGR;AM/FA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANiGJ;AM9FA;EACI,yBAAA;EACA,iBAAA;ANgGJ;AM7FA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN+FJ;AM5FA;;EAEI,sBAAA;AN8FJ;AM3FA;EACI,kBAAA;AN6FJ;AMzFI;EACI,aAAA;AN2FR;AMvFA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANyFJ;AMpFQ;EACI,gBAAA;EACA,cAAA;ANsFZ;AMlFY;EACI,cAAA;ANoFhB;AOvPA;EACI,UAAA;APyPJ;AOvPI;EACI,oBAAA;APyPR;AOtPI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;APwPR;AOtPQ;EACI,UAAA;APwPZ;AOtPY;EACI,0BAAA;EHCZ,eAAA;EACA,iBGDgC;EHEhC,gBGFsC;EHGtC,iBGH2C;EAC/B,cNKY;ADsP5B;AOvPQ;EACI,UAAA;APyPZ;AOvPY;EACI,+BCzBS;EJgBrB,eGU0B;EHT1B,iBGSgC;EHRhC,gBGQsC;EHPtC,iBAJqE;EGYzD,cNLY;EMMZ,iBAAA;EACA,kBAAA;AP4PhB;AOzPY;EACI,+BCjCS;EJgBrB,eGkB0B;EHjB1B,iBGiBgC;EHhBhC,gBGgBsC;EHftC,iBAJqE;EGoBzD,cNbY;EMcZ,iBAAA;AP8PhB;AOzPI;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;AP2PR;AOzPQ;EACI,UAAA;EACA,+BCrDa;EJgBrB,eGsCsB;EHrCtB,iBGqC4B;EHpC5B,gBGoCkC;EHnClC,iBGmCuC;EAC/B,cNjCgB;AD+R5B;AO3PQ;EACI,UAAA;EACA,+BC5Da;EJgBrB,eG6CsB;EH5CtB,iBG4C4B;EH3C5B,gBG2CkC;EH1ClC,iBAJqE;EG+C7D,cNxCgB;EMyChB,cAAA;EACA,iBAAA;APgQZ;AO3PQ;EACI,+BCtEa;EJgBrB,eGuDsB;EHtDtB,iBGsD4B;EHrD5B,gBGqDkC;EHpDlC,iBAJqE;EGyD7D,cNlDgB;EMmDhB,WAAA;EACA,eAAA;APgQZ;AO7PQ;EACI,wDAAA;EACA,WAAA;EACA,kBAAA;EACA,iCNjEY;EMkEZ,sBAAA;AP+PZ;AO5PQ;EACI,mBAAA;EAEA,4BAAA;AP6PZ;AOvPA;EACI;IACI,eAAA;EPyPN;EOtPU;IHnFR,eGoF0B;IHnF1B,iBGmFgC;IHlFhC,gBGkFsC;IHjFtC,iBAJqE;EJgVvE;EOzPU;IACI,kBAAA;EP2Pd;EOxPM;IACI,WAAA;IACA,sBAAA;EP0PV;EOxPU;IACI,WAAA;EP0Pd;EOxPc;IHjGZ,eGkG8B;IHjG9B,iBGiGoC;IHhGpC,gBGgG0C;IH/F1C,iBAJqE;EJgWvE;EOzPU;IACI,WAAA;EP2Pd;EOzPc;IACI,gBAAA;IH1GhB,eG2G8B;IH1G9B,iBG0GoC;IHzGpC,gBGyG0C;IHxG1C,iBAJqE;IG6GrD,kBAAA;EP8PlB;EO5Pc;IACI,gBAAA;IH/GhB,eGgH8B;IH/G9B,iBG+GoC;IH9GpC,gBG8G0C;IH7G1C,iBAJqE;IGkHrD,eAAA;EPiQlB;EO7PM;IACI,WAAA;IACA,sBAAA;IACA,iBAAA;EP+PV;EO7PU;IH1HR,eG2H0B;IH1H1B,iBG0HgC;IHzHhC,gBGyHsC;IHxHtC,iBAJqE;IG6HzD,WAAA;EPkQd;EOhQU;IACI,+BC/IS;IJgBrB,eGgI0B;IH/H1B,iBG+HgC;IH9HhC,gBG8HsC;IH7HtC,iBAJqE;IGkIzD,cN3HY;IM4HZ,WAAA;IACA,gBAAA;IACA,gBAAA;EPqQd;EOhQc;IACI,cAAA;IACA,gBAAA;EPkQlB;AACF;;AAhaA;ECJA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EGuCA,eAAA;EA2GA,2BAAA;EA8DA,gBAAA;AT6PA;AKtcA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALwcJ;AKtcI;EAEI,sBAAA;ALucR;AKpcI;EACI,wBAAA;ALscR;AKlcA;;EAEI,SAAA;EACA,iBAAA;ALocJ;AKjcA;EACI,WAAA;ALmcJ;AKhcA;EACI,WAAA;ALkcJ;AK/bA;;;;;EAKI,SAAA;ALicJ;AK9bA;;;;;;;;;;;;EAYI,oBAAA;ALgcJ;AK7bA;EACI,OAAA;AL+bJ;AK7bI;EACI,WAAA;AL+bR;AK5bI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AL6bR;AKzbA;EACI,WAAA;AL2bJ;AKxbA;EACI,YAAA;AL0bJ;AM1gBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN4gBJ;AMzgBA;;;;;;;;;;;;EAYI,cAAA;AN2gBJ;AMxgBA;;EAEI,gBAAA;AN0gBJ;AMvgBA;;EAEI,YAAA;ANygBJ;AMvgBI;;;;EAEI,aAAA;AN2gBR;AMvgBA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANygBJ;AMtgBA;EACI,yBAAA;EACA,iBAAA;ANwgBJ;AMrgBA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANugBJ;AMpgBA;;EAEI,sBAAA;ANsgBJ;AMngBA;EACI,kBAAA;ANqgBJ;AMjgBI;EACI,aAAA;ANmgBR;AM/fA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANigBJ;AM5fQ;EACI,gBAAA;EACA,cAAA;AN8fZ;AM1fY;EACI,cAAA;AN4fhB;AS7pBI;EACI,cRCS;AD8pBjB;AS5pBI;EACI,cRHS;ADiqBjB;AS3pBI;EACI,cRTyB;ADsqBjC;AS1pBI;EACI,cRZiB;ADwqBzB;ASzpBI;EACI,cRfS;AD0qBjB;ASxpBI;EACI,cRrByB;AD+qBjC;ASvpBI;EACI,iCRtBS;AD+qBjB;AStpBI;EACI,cR7ByB;ADqrBjC;ASnpBA;EAEQ;IACI,eAAA;ETopBV;ESjpBM;IACI,aAAA;ETmpBV;EShpBM;IACI,+BD7Ca;IC8Cb,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;ETkpBV;ES/oBM;IACI,+BDrDa;ICsDb,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;ETipBV;ES9oBM;IACI,gCDhEc;ICiEd,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,eAAA;ETgpBV;ES7oBM;IACI,gCDxEc;ICyEd,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;ET+oBV;ES5oBM;IACI,iBAAA;IACA,+BD9Ea;ER4tBvB;ES3oBM;IACI,gCDrFc;ICsFd,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;ET6oBV;ES1oBM;IACI,WAAA;ET4oBV;ESxoBU;IACI,aAAA;ET0oBd;ESvoBU;IACI,iBAAA;IACA,mBAAA;ETyoBd;ESpoBU;IACI,+BD7GS;IC8GT,eAAA;IACA,iBAAA;ETsoBd;ESnoBU;IACI,uBAAA;ETqoBd;ESloBU;IACI,mBAAA;ETooBd;ESjoBU;IACI,kBAAA;ETmoBd;ES7nBM;IACI,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;ET+nBV;ES5nBM;IACI,eAAA;ET8nBV;AACF;ASznBA;EAEQ;IACI,sBAAA;ET0nBV;ESvnBM;IACI,cAAA;IACA,oBAAA;ETynBV;ESrnBU;IACI,cAAA;IACA,iBAAA;ETunBd;ESpnBU;IACI,iBAAA;IACA,mBAAA;ETsnBd;ESjnBU;;IAEI,aAAA;ETmnBd;EShnBU;IACI,+BD7KS;ER+xBvB;ES/mBU;IACI,+BD/KS;ICgLT,gBAAA;ETinBd;ES9mBU;IACI,gBAAA;IACA,gBAAA;IACA,+BDtLS;ICuLT,gBAAA;ETgnBd;ES1mBM;IACI,mBAAA;IACA,kBAAA;ET4mBV;ESxmBU;IACI,iBAAA;ET0mBd;AACF;ASpmBA;EAEQ;IACI,2BAAA;ETqmBV;ESlmBM;IACI,uBAAA;ETomBV;ESjmBM;IACI,WAAA;IACA,YAAA;IACA,mBAAA;ETmmBV;ESjmBU;IACI,cAAA;IACA,gBAAA;ETmmBd;EShmBU;IACI,kBAAA;ETkmBd;ES9lBM;IACI,YAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;ETgmBV;ES9lBU;IACI,gCD9OU;IC+OV,gBAAA;ETgmBd;ES7lBU;IACI,gBAAA;IACA,gBAAA;IACA,gCDrPU;ICsPV,gBAAA;ET+lBd;ESxlBU;IACI,cAAA;ET0lBd;AACF","sourcesContent":[":host-context(.aulani) {\r\n    @import './about-olci.component.aulani.scss';\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './about-olci.component.wdw.scss';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.why-olci {\r\n    padding: 0;\r\n\r\n    .all-sections-on-file {\r\n        padding-bottom: 12px;\r\n    }\r\n\r\n    .header-section {\r\n        float: left;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n        .left-header {\r\n            width: 50%;\r\n\r\n            .olci-header {\r\n                font-family: Goudy-Regular;\r\n                @include font(48px, 44px, 400, 0);\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .right-header {\r\n            width: 50%;\r\n\r\n            .resort-name {\r\n                font-family: $inspiretwdc-roman-font;\r\n                @include font(18px, 27px, 600);\r\n                color: $aulani-primary-text-color;\r\n                text-align: right;\r\n                margin-bottom: 5px;\r\n            }\r\n    \r\n            .period-of-stay {\r\n                font-family: $inspiretwdc-roman-font;\r\n                @include font(18px, 27px, 600);\r\n                color: $aulani-primary-text-color;\r\n                text-align: right;\r\n            }\r\n        }\r\n    }\r\n\r\n    .info-section {\r\n        float: left;\r\n        margin-left: 0;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: flex-end;\r\n        padding-top: 24px;\r\n        padding-bottom: 12px;\r\n\r\n        .description {\r\n            width: 50%;\r\n            font-family: $inspiretwdc-roman-font;\r\n            @include font(18px, 27px, 400, 0);\r\n            color: $aulani-primary-text-color;\r\n        }\r\n\r\n        .required-field {\r\n            width: 50%;\r\n            font-family: $inspiretwdc-roman-font;\r\n            @include font(18px, 27px, 400);\r\n            color: $aulani-primary-text-color;\r\n            display: block;\r\n            text-align: right;\r\n        }\r\n    }\r\n\r\n    .aulani-info {\r\n        .title {\r\n            font-family: $inspiretwdc-roman-font;\r\n            @include font(28px, 40px, 500);\r\n            color: $aulani-primary-text-color;\r\n            width: auto;\r\n            margin-top: 0px;\r\n        }\r\n\r\n        .horizontal-line {\r\n            background-image: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n            height: 1px;\r\n            margin: 0 0 32px 0;\r\n            border-bottom: $primary-aulani-border;\r\n            background-image: none;\r\n        }\r\n\r\n        .aulani-global-error {\r\n            margin-bottom: 20px;\r\n\r\n            --font16_-_line-height: 21px;\r\n        }\r\n    }\r\n}\r\n\r\n/* For Mobile devices */\r\n@media only screen and (max-width: 767px) {\r\n    .why-olci {\r\n        padding: 0 20px;\r\n\r\n        .aulani-info {\r\n            .title {\r\n                @include font(24px, 32px, 600);\r\n            }\r\n            .horizontal-line {\r\n                margin: 0 0 32px 0;\r\n            }\r\n        }\r\n        .header-section {\r\n            width: 100%;\r\n            flex-direction: column;\r\n\r\n            .left-header {\r\n                width: 100%;\r\n\r\n                .olci-header {\r\n                    @include font(32px, 38px, 400);\r\n                }\r\n            }\r\n\r\n            .right-header {\r\n                width: 100%;\r\n\r\n                .resort-name {\r\n                    text-align: left;\r\n                    @include font(16px, 24px, 600);\r\n                    margin: 12px 0 0 0;\r\n                }\r\n                .period-of-stay {\r\n                    text-align: left;\r\n                    @include font(16px, 24px, 600);\r\n                    margin-top: 5px;\r\n                }\r\n            }\r\n        }\r\n        .info-section {\r\n            width: 100%;\r\n            flex-direction: column;\r\n            padding-top: 24px;\r\n\r\n            .description {\r\n                @include font(16px, 24px, 400);\r\n                width: 100%;\r\n            }\r\n            .required-field {\r\n                font-family: $inspiretwdc-roman-font;\r\n                @include font(16px, 24px, 400);\r\n                color: $aulani-primary-text-color;\r\n                width: 100%;\r\n                text-align: left;\r\n                margin-top: 12px;\r\n            }\r\n        }\r\n        &.all-sections-on-file {\r\n            .info-section {\r\n                .required-field {\r\n                    display: block;\r\n                    margin-top: 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n\r\n.why-olci {\r\n    .title {\r\n        color: $wdw-h3-heading;\r\n    }\r\n\r\n    h2 {\r\n        color: $wdw-h3-heading;\r\n    }\r\n\r\n    .period-of-stay {\r\n        color: $wdw-primary-message-text-color;\r\n    }\r\n\r\n    .description {\r\n        color: $wdw-primary-text-color;\r\n    }\r\n\r\n    .descriptionDOF {\r\n        color: $wdw-h3-heading;\r\n    }\r\n\r\n    .required-field {\r\n        color: $wdw-primary-message-text-color;\r\n    }\r\n\r\n    .horizontal-line {\r\n        border-bottom: $primary-border;\r\n    }\r\n\r\n    .resort-name {\r\n        color: $wdw-primary-message-text-color;\r\n    }\r\n}\r\n\r\n/* For MOBILE */\r\n@media only screen and (min-width: 320px) {\r\n    .why-olci {\r\n        .parent-container {\r\n            padding: 0 10px;\r\n        }\r\n\r\n        .content-container + div.horizontal-line {\r\n            display: none;\r\n        }\r\n\r\n        .title {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-weight: 400;\r\n            font-size: 24px;\r\n            letter-spacing: 0;\r\n            line-height: 33px;\r\n        }\r\n\r\n        h2 {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-weight: 400;\r\n            font-size: 24px;\r\n            letter-spacing: 0;\r\n            line-height: 33px;\r\n        }\r\n\r\n        .period-of-stay {\r\n            font-family: $inspiretwdc-medium-font;\r\n            font-weight: 400;\r\n            font-size: 12px;\r\n            letter-spacing: 0;\r\n            margin-top: 6px;\r\n        }\r\n\r\n        .description {\r\n            font-family: $inspiretwdc-medium-font;\r\n            font-weight: 400;\r\n            font-size: 14px;\r\n            letter-spacing: 0;\r\n            line-height: 21px;\r\n        }\r\n\r\n        .descriptionDOF {\r\n            line-height: 20px;\r\n            font-family: $inspiretwdc-roman-font;\r\n        }\r\n\r\n        .required-field {\r\n            font-family: $inspiretwdc-medium-font;\r\n            font-weight: 400;\r\n            font-size: 12px;\r\n            letter-spacing: 0;\r\n            line-height: 28px;\r\n            margin-top: -7px;\r\n        }\r\n\r\n        .horizontal-line {\r\n            height: 1px;\r\n        }\r\n\r\n        .left-section {\r\n            .title {\r\n                display: none;\r\n            }\r\n\r\n            .description {\r\n                padding-top: 24px;\r\n                margin-bottom: 10px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            .resort-name {\r\n                font-family: $inspiretwdc-heavy-font;\r\n                font-size: 14px;\r\n                letter-spacing: 0;\r\n            }\r\n\r\n            .horizontal-line {\r\n                margin: 24px -10px 20px;\r\n            }\r\n\r\n            .title {\r\n                margin-bottom: 40px;\r\n            }\r\n\r\n            .required-field {\r\n                margin-bottom: 0px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .why-olci.all-sections-on-file {\r\n        .content-container + div.horizontal-line {\r\n            display: block;\r\n            margin-top: 15px;\r\n            margin-left: -10px;\r\n            margin-right: -10px;\r\n        }\r\n\r\n        .required-field {\r\n            margin-top: 7px;\r\n        }\r\n    }\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n@media only screen and (min-width: 768px) {\r\n    .why-olci {\r\n        .parent-container {\r\n            padding: 0 40px 0 40px;\r\n        }\r\n\r\n        .content-container + div.horizontal-line {\r\n            display: block;\r\n            margin: 30px -40px 0;\r\n        }\r\n\r\n        .left-section {\r\n            .title {\r\n                display: block;\r\n                padding-top: 40px;\r\n            }\r\n\r\n            .description {\r\n                padding-top: 10px;\r\n                margin-bottom: 15px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            .title,\r\n            .horizontal-line {\r\n                display: none;\r\n            }\r\n\r\n            .resort-name {\r\n                font-family: $inspiretwdc-heavy-font;\r\n            }\r\n\r\n            .period-of-stay {\r\n                font-family: $inspiretwdc-roman-font;\r\n                font-weight: 400;\r\n            }\r\n\r\n            .required-field {\r\n                margin-top: 11px;\r\n                margin-bottom: 0;\r\n                font-family: $inspiretwdc-roman-font;\r\n                font-weight: 400;\r\n            }\r\n        }\r\n    }\r\n\r\n    .why-olci.all-sections-on-file {\r\n        .content-container + div.horizontal-line {\r\n            margin-right: -40px;\r\n            margin-left: -40px;\r\n        }\r\n\r\n        .left-section {\r\n            .description {\r\n                padding-top: 24px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media screen and (min-width: 992px) {\r\n    .why-olci {\r\n        .parent-container {\r\n            padding: 40px 40px 0px 40px;\r\n        }\r\n\r\n        .content-container + div.horizontal-line {\r\n            margin: 0 -40px 0 -40px;\r\n        }\r\n\r\n        .left-section {\r\n            float: left;\r\n            width: 535px;\r\n            margin-bottom: 30px;\r\n\r\n            .title {\r\n                display: block;\r\n                padding-top: 0px;\r\n            }\r\n\r\n            .description {\r\n                margin-bottom: 0px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            float: right;\r\n            width: 309px;\r\n            text-align: right;\r\n            margin-top: 9px;\r\n\r\n            .period-of-stay {\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-weight: 400;\r\n            }\r\n\r\n            .required-field {\r\n                margin-top: 10px;\r\n                margin-bottom: 0;\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-weight: 400;\r\n            }\r\n        }\r\n    }\r\n\r\n    .why-olci.all-sections-on-file {\r\n        .left-section {\r\n            .description {\r\n                padding-top: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
